import { BaseActionProps } from "@/components/common/adCard/types";
import { Button } from "@/components/ui/button";
import { IconEditCircle } from "@tabler/icons-react";

interface Props extends BaseActionProps {
  onClick: () => void;
}

const EditImageAction = ({ onClick }: Props) => {
  return (
    <Button
      onClick={onClick}
      className="pointer-events-auto border-0 flex h-[30px] items-center gap-[6px] bg-[#00000099] backdrop-blur-sm hover:bg-[#000000CC] shadow-sm text-[12px] font-normal leading-[16px] text-[#fff] cursor-pointer focus:outline-none focus:ring-0"
    >
      <IconEditCircle size={16} color="#fff" />
      <span className="text-[#FFF] text-[12px] font-normal leading-[19.157px] tracking-[0.24px]">
        Edit
      </span>
    </Button>
  );
};

export default EditImageAction;
